<template>
  <div class="input-group">
    <div class="input-group-append">
      <span class="input-group-text">
        <i class="far fa-calendar-alt"></i>
      </span>
    </div>
    <input
      type="text"
      readonly
      class="form-control text-right"
      :placeholder="$t('search-tab.choose-date')"
      @click="toggleCalendar"
      style="cursor: auto"
      :value="inputText"
      ref="inputControl"
      dir="ltr"
    />
    <div class="col-12 calendar-body" v-if="show">
      <div class="card mb-2 calendar-card">
        <div class="card-text p-2">
          <div class="row">
            <div v-for="(monthYear, i) of monthYears" :key="i" class="month-container" :style="{ width: 100 / noOfMonthsInRow + '%' }">
              <table>
                <thead>
                  <tr>
                    <th class="text-center month-title" :colspan="weekDays.length">
                      <span v-if="i == 0" class="float-left" style="cursor: pointer; padding-left: 8px" @click="nextMonth">
                        <i class="arrow left"></i>
                      </span>
                      {{ displayMonthYear(monthYear) }}
                      <span v-if=" (noOfMonthsInRow == 1 && i == 0) || (noOfMonthsInRow == 2 && i == 1)"
                      class="float-right" style="cursor: pointer; padding-right: 8px" @click="previousMonth">
                        <i class="arrow right"></i>
                      </span>
                    </th>
                  </tr>
                  <tr>
                    <th v-for="(weekDay, i) of weekDays" :key="i" class="day-header text-center">
                      {{ weekDay }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(daysOfWeek, i) of weekWiseDays(monthYear)" :key="i">
                    <td
                      v-for="(day, j) of daysOfWeek"
                      :key="j"
                      class="text-center"
                      :title="isHoliday(day)"
                      :class="{
                        available: isAvailable(day)
                          ? true
                          : false,
                        'start-date': isStartDate(day),
                        'end-date': isEndDate(day),
                        'under-selection': isUnderSelection(
                          day
                        ),
                        holiday: !!isHoliday(day),
                        today: isToday(day)
                      }"
                      @click="
                        isAvailable(day)
                          ? selectDate(day)
                          : null
                      "
                      @mouseenter="
                        isAvailable(day)
                          ? enterDate(day)
                          : null
                      "
                    >
                      <div v-if="day">
                        {{ day.format("D") }}
                        <!-- <div class="price-text">
                          {{ dayPrice(day) }}
                        </div> -->
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="d-flex flex-row">
            <ul
              class="reference-list d-flex p-0 align-self-center m-0"
              style="color: black;"
              v-if="showNotify"
            >
              <li class="d-flex">
                <div class="reference holiday m-1"></div>
                {{ $t("calendar.holiday") }}
              </li>
            </ul>
            <div
              class="flex-fill m-1"
              :class="{ 'm-1': type !== 'side' }"
            >
              <button
                class="btn btn-secondary btn-sm btn-block"
                @click="clearDatesSelection"
                :disabled="
                  selectionDate1 == null ? true : false
                "
              >
                {{ $t("calendar.clear") }}
              </button>
            </div>
            <div class="flex-fill m-1">
              <button class="btn btn-primary btn-sm btn-block" @click="finalizeSelection" :disabled="selectionDate1 && selectionDate2 ? false : true">
                {{ $t("calendar.continue") }}
              </button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import TemplateCustomDatepicker from './TemplateCustomDatepickerRange';

require('dayjs/locale/he');
require('dayjs/locale/ru');
require('dayjs/locale/ar');

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export default {
  name: 'CustomDatepickerRange',
  mixins: [TemplateCustomDatepicker],
};
</script>

<style scoped>
.filter-tab .input-group > .form-control, .filter-tab .input-group > .form-control:not(:last-child) {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
  background-color: #fff;
}
.sportspage_area form .input-group-append .input-group-text, .boxSideSearch .input-group-append .input-group-text{
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.filter-tab form .input-group-append .input-group-text {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  background-color: #fff;
}
.filter-tab .input-group > .form-control:not{
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}
.calendar-body .month-title {
  color: black;
}
.calendar-body {
  position: absolute;
  top: 50px;
  z-index: 10;
}
.calendar-card {
  min-width: 250px;
}
.month-container {
  padding: 10px;
}

.month-container table {
  width: 100%;
  margin-bottom: 10px;
}

.month-container td {
  color: #c3ceda;
  pointer-events: none;
  cursor: default;
}

.today {
  color: #95a5b9;
  background-color: #ebf0f1;
}

.month-container .day-header {
  color: #23BEDC;
}

.month-container td.start-date,
.month-container td.under-selection {
  background-color: #23BEDC !important;
  color: #fff !important;
}
.month-container td.start-date div {
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
  background-color: #23BEDC !important;
}
.month-container td.start-date {
  background-color: #c2ebd2 !important;
}
.month-container td.end-date div {
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  background-color: #23BEDC !important;
}
.month-container td.end-date {
  background-color: #c2ebd2 !important;
}

.month-container td.available {
  pointer-events: all;
  background-color: #c2ebd2;
  color: #000;
  cursor: pointer;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}

.reference.available,
.month-container td.available {
  pointer-events: all;
  background-color: #e0efff;
  color: #000;
  cursor: pointer;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  /* background-image: linear-gradient(-45deg, #e0efff 65%, #0db04b 35%); */
  /* background-image: linear-gradient(-45deg, #b6ddff, #fff, #b6ddff); */
  /* border-radius: 3px; */
}

.month-container td.holiday:after {
  content: "";
  height: 18px;
  left: 0;
  position: absolute;
  top: 0;
  width: 18px;
}
.reference.holiday,
.month-container td.holiday:after {
  background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDY5LjU1IDY5LjU1Ij48ZGVmcz48c3R5bGU+LmNscy0ye2ZpbGw6I2ZmZn08L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNNjkuNTUgMCAwIDY5LjU1VjBoNjkuNTVabTAgMCIgc3R5bGU9ImZpbGw6IzAxNzJkZiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTkuNzQgMjUuNDFhNi4xOCA2LjE4IDAgMCAxIDEuNDgtMS4xNSAyLjczIDIuNzMgMCAwIDEgMS4zNC0uMzMgMi42NSAyLjY1IDAgMCAxIDEuMjkuNCA2LjgyIDYuODIgMCAwIDEgMS4zMSAxLjA2bDYuMTEgNi4xMWExMi43NyAxMi43NyAwIDAgMCAyLjQxIDEuOSAxNC44IDE0LjggMCAwIDAgMi40NCAxLjIxTDIzLjcyIDM3YTUgNSAwIDAgMS0xLjM3LS41OSAxMi4yOSAxMi4yOSAwIDAgMS0xLjI3LS44NmMtLjQ0LS4zNS0uODctLjcyLTEuMy0xLjExYTcuNDYgNy40NiAwIDAgMSAuODEgMS42IDUuMTkgNS4xOSAwIDAgMSAuMzIgMS45NiA0LjI3IDQuMjcgMCAwIDEtLjQ0IDEuODkgNi41MiA2LjUyIDAgMCAxLTEuMjYgMS43bC0xLjA3IDEuMDEtMi4yMS0yLjIxIDEuMzEtMS4zYTQuNCA0LjQgMCAwIDAgMS0xLjg3IDQuNzUgNC43NSAwIDAgMCAuMS0xLjkxIDUuNDYgNS40NiAwIDAgMC0uNjQtMS44MSA3Ljg3IDcuODcgMCAwIDAtMS4yOS0xLjY4bC0zLjc2LTMuNzZhMSAxIDAgMCAwLS41OS0uMzUuOS45IDAgMCAwLS42NC4zNWwtMi4xNCAyLjE4LTIuMTgtMi4xOVpNMzAuNTIgOWwtMS4xNyAxLjE3TDQwIDIwLjc5bC0yLjYzIDIuNjEtMTAuNjUtMTAuNjUtNC44NCA0Ljg0IDEwLjY0IDEwLjY1LTIuNjIgMi42Mi0xMC42Mi0xMC42Mi0xLjIxIDEuMjEtMi4xOS0yLjE5TDI4LjM0IDYuODFaIi8+PC9zdmc+);
  background-position: 0 0;
  background-repeat: no-repeat;
}

.month-container td .price-text {
  font-size: 9px;
}

.month-container table {
  width: 100%;
}

.month-container th,
.month-container td > div {
  padding: 5px;
}
.month-container td {
  padding: 0;
  position: relative;
}

.month-title {
  font-weight: bolder;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.arrow.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.arrow.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}
.reference-list li {
  list-style: none;
}

.reference {
  width: 18px;
  height: 18px;
}
</style>
